module.exports = __webpack_public_path__ + "static/media/icon_alerta.f1ec6981.svg";